import { jsx as f } from "react/jsx-runtime";
import { BaseIcon as s } from "../BaseIcon/index.js";
function x({ m: o, mb: r, ml: i, mr: n, mt: t, icon: c, id: e, size: m, color: p }) {
  return /* @__PURE__ */ f(
    s,
    {
      m: o,
      mb: r,
      ml: i,
      mr: n,
      mt: t,
      icon: c,
      id: e,
      size: m,
      color: p,
      description: void 0
    }
  );
}
export {
  x as Icon
};
//# sourceMappingURL=index.js.map
